export const columnLayout = () => {
  const gridColumnLayOut = [
    {
      dataField: "month",
      headerText: "월별",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      labelFunction: function (rowIndex, columnIndex, value, headerText, item) {
        return value.substring(0, 4) + "-" + value.substring(4);
      },
    },
    {
      dataField: "plantCd",
      headerText: "사업장코드",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantNm",
      headerText: "사업장명",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "scrapAreaCd",
      headerText: "하차지역",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "scrapAreaNm",
      headerText: "하차지역",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "heavyScrap",
      headerText: "중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      editRenderer: {
        type: "InputEditRenderer",
        onlyNumeric: true, // 0~9만 입력가능
        textAlign: "right", // 오른쪽 정렬로 입력되도록 설정
        autoThousandSeparator: true, // 천단위 구분자 삽입 여부
      },
    },
    {
      dataField: "lightScrap",
      headerText: "경량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      editRenderer: {
        type: "InputEditRenderer",
        onlyNumeric: true, // 0~9만 입력가능
        textAlign: "right", // 오른쪽 정렬로 입력되도록 설정
        autoThousandSeparator: true, // 천단위 구분자 삽입 여부
      },
    },
    {
      dataField: "turningScrap",
      headerText: "선반",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      editRenderer: {
        type: "InputEditRenderer",
        onlyNumeric: true, // 0~9만 입력가능
        textAlign: "right", // 오른쪽 정렬로 입력되도록 설정
        autoThousandSeparator: true, // 천단위 구분자 삽입 여부
      },
    },
  ];
  return gridColumnLayOut;
};
